import { FileText, Image, Table } from 'lucide-react';
import type { GcsFileInfo } from '@/client/app/hooks/useAccountFiles';

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function fileIcon(contentType: string) {
  if (contentType.startsWith('image/')) return Image;
  if (contentType.includes('csv') || contentType.includes('spreadsheet')) return Table;
  return FileText;
}

export function groupFiles(files: GcsFileInfo[]) {
  const groups: Record<string, GcsFileInfo[]> = {
    reports: [],
    exports: [],
    charts: [],
    other: [],
  };

  for (const file of files) {
    if (file.path.includes('/reports/')) groups.reports.push(file);
    else if (file.path.includes('/exports/')) groups.exports.push(file);
    else if (file.path.includes('/charts/') || file.path.includes('/dashboards/'))
      groups.charts.push(file);
    else groups.other.push(file);
  }

  return groups;
}

export const SECTION_LABELS: Record<string, string> = {
  reports: 'Reports',
  exports: 'Data Exports',
  charts: 'Charts & Dashboards',
  other: 'Other Files',
};
